import React from "react";
import PropTypes from "prop-types";
import mapHtmlToReact, { domToReact, attributesToProps } from "html-react-parser";
import { H1, H2, H3, H4, H5, H6 } from "./components/Headings";
import P from "./components/Paragraph";
import Sup from "./components/Sup";
import { Ordered, Unordered, Item } from "./components/Lists";
import Image from "./components/Image";
import Wrapper from "./components/Wrapper";
const defaultMappings = {
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
  ol: Ordered,
  ul: Unordered,
  li: Item,
  img: Image,
  p: P,
  sup: Sup
};

const HtmlFragment = _ref => {
  let {
    content,
    mappings: mappingOverrides = {},
    ...props
  } = _ref;
  const mappings = { ...defaultMappings,
    ...mappingOverrides
  };
  return /*#__PURE__*/React.createElement(Wrapper, props, mapHtmlToReact(content, {
    replace: domNode => {
      if (Object.keys(mappings).includes(domNode.name)) {
        const Component = mappings[domNode.name];
        const props = attributesToProps(domNode.attribs);
        return /*#__PURE__*/React.createElement(Component, props, domNode.children && domNode.children.length > 0 ? domToReact(domNode.children) : null);
      }
    }
  }));
};

HtmlFragment.propTypes = {
  /** The HTML string that is to be parsed */
  content: PropTypes.string.isRequired,

  /** Overrides for the component mappings where keys match element names and values are functions that accept props and return react elements */
  mappings: PropTypes.object,

  /** Theme for changing text and link colors */
  theme: PropTypes.shape({
    textColor: PropTypes.string,
    linkColor: PropTypes.string,
    linkHoverColor: PropTypes.string
  })
};
export default HtmlFragment;